export default {
    totals: 'Totales',
    grand_total: 'Total General',
    work_type: 'Actividades',
    quantity: 'Cantidad',
    total_time: 'Tiempo total',
    call: {
        category: 'Categoria',
        total_ticket: 'Tickets totales',
        total_worklload: 'Cargas de trabajo totales',
        total_time_agreed_load: 'Tiempo Total Acordado',
        agreed_load_variation_percent: 'Diferencia del Tiempo Acordado',
        time_limit_sla: 'Tiempo Límite del SLA',
        sla_variation_percent: 'Diferencia del SLA',
    },
    task: {
        type: 'Tipo de Tarea',
        quantity_task: 'Cantidad de Tareas',
        quantity_items_checklist: 'Cantidad de Ítems del Checklist',
        quantity_items_checklist_completed: 'Cantidad de Ítems Completados',
        total_time_estimated: 'Tiempo Total Estimado',
        total_time_workload: 'Tiempo Total de Trabajo Real',
        workload_variation_percent: 'Precisión del Tiempo Estimado'
    }
}
